import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalValue,
  IsSmallScreen,
  LoacalVariables,
  MasterPages,
  updateMainHeader,
} from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import {
  AllPermissions,
  getPermissions,
  IPermission,
} from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, {
  IOrderColumns,
} from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import ConfirmationPopup, {
  IMethodAction,
} from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../Components/Button/WSButton";
import AddIcon from "@mui/icons-material/Add";
import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import AddDoctorDialog from "./Drawyers/AddDoctorDialog";

export const DoctorTabList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const { add, edit, remove } = getPermissions("doctors"); // role permissions for this page
  const [action, setAction] = useState<IMethodAction>("DELETE");
  const [apiUrl, setApiUrl] = useState<any>(null);
  const [bodyData, setBodyData] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [addDoctorOpen, setAddDoctorOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  // AllPermissions.getInstance();
  // const { add, edit, remove, view } = AllPermissions.getUserPermission;

  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  breadCrumbsStore.updateBreadCrumbs([
    { "Doctors": "Doctors" }
  ]);
  const [productSource, setProductSource] = useState<any>({
        url: "Auth/search",
        page: 1,
        pageSize: 10,
        filter: [
            { field: "userType", operator: "eq", value: "doctor" },
            { field: "isActive", operator: "eq", value: "true" },
        ],
        sort: [
            {
                "field": "UpdatedAt",
                "direction": "desc"
            }
        ],
    })

 const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "Auth/search",
            page: 1,
            pageSize: 10,
            filter: [
                { field: "userType", operator: "eq", value: "doctor" },
            { field: "isActive", operator: "eq", value: "true" },
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
    switch (value) {
      case 'In Stock':
        soureFilter.filter = [{
          "field": "name",
          "operator": "eq",
          "value": "In Stock"
        }]
        break

    }
    setProductSource({ ...soureFilter });
  }
  const source = {
    url: "Auth/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "userType",
        operator: "eq",
        value: "doctor",
      },
      { field: "isActive", operator: "eq", value: "true" },
    ],
    sort: [
      {
        field: "UpdatedAt",
        direction: "desc",
      },
    ],
  };

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/doctor/profile/edit/${row?.id}`);
    } else if (action === "Approve") {
      setAction("POST");
      setApiUrl(`DoctorProfile/${row?.id}/approve`);
      setSelectedId(null); // Set the ID of the row to be deleted
      setPopupOpen(true);
      setBodyData({ approvedBy: getLocalValue(LoacalVariables.UserId) });
    } else if (action === "Update Profile") {
      navigate(`/doctor/profile/add/${row?.id}`);
    } else if (action === "Schedule") {
      navigate(`/doctor/profile/add/${row?.id}/schedule`)
    }
  };
  const handleStatusClick = async (evt: any, row: any) => {
    navigate(`/doctor/profile/add/${row?.id}`);
  };
  const handleConfirm = (response: any) => {
    dispatch(resetDataComponent("doctorListGrid"));
    showMessage(response?.message, response?.success ? "success" : "error");
  };
  const filterRows: IHeaderRows[] = [
    {
      label: "Status",
      fieldName: "IsProfileComplete",
      type: "dropdown",
      options: [
        { label: "Completed", value: "true" },
        { label: "Incomplete", value: "false" },
      ],

      operator: "eq",
      rowDivision: 3,
    },
    // {
    //     label: "Last Name",
    //     fieldName: "LastName",
    //     type: "text",
    //     operator: 'like',
    //     rowDivision: 6
    // },
  ];
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      type: "default",
      // sortable: true
    },
    // {
    //   header: "Email",
    //   fieldName: "email",
    //   tooltip: true,
    //   type: "default",
    // },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      isHide: isMobile,
      type: "default",
    },
    {
      header: "Approval Status",
      fieldName: "profileStatus",
      tooltip: true,
      isHide: isMobile,
      type: "status",
    },
    {
      header: "Status",
      fieldName: "status",
      isHide: isMobile,
      isTitleCase: true,
      type: "status",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit", edit && "Approve", edit && "Update Profile"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      // fieldCompare: { fieldName: 'status', ValueCheck: { value: 'Completed', actionCheck: "Completed" } },
      // hideAction: {
      //     actionName: [{ fieldName: 'status', hideAction: ['Edit'], values: ['In Complete'] }]

      // }
      hideSelectedActions: {
        fieldToHide: [
           {
            field: "profileStatus",
            hideValue: ["Approved"],
            hideActions: ["Approve"],
          },
          {
            field: "status",
            hideValue: ["Completed"],
            hideActions: ["Update Profile"],
          },
          {
            field: "status",
            hideValue: ["Incomplete"],
            hideActions: ["Edit", "Approve", "Schedule"],
          },
         
        ],
      },
    },
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      labelSx: { fontWeight: "bold" },
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,

      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isBoderRadious: true,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isBoderRadious: true,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any, index: number) => {
        item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ""
          }`;
        item.status =
          item?.isProfileComplete === false ? "Incomplete" : "Completed";
        item.profileStatus =
          item?.isApproved === false ? "Pending" : "Approved";
      });
      return data;
    }
  };
  return (
    <Grid >
      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup options={filters} selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }} />
        </Grid>
        {add && (
          <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
            <WSButton
              id="btnAddDoctor"
              label="Add Doctor"
              startIcon={<AddIcon />}
              onClick={() => setAddDoctorOpen(true)}
              sx={{
                borderRadius: "999px",
                backgroundColor: "#098963!important",
                textTransform: "none",
                fontWeight: 500,
                height: "35px!important",
                fontSize: "0.875rem!important",
                paddingX: 3,
                paddingY: 1,
                "&:hover": {
                  backgroundColor: "#087654!important",
                },
              }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="doctorListGrid"
              title="Doctors"
              columns={columns}
              source={productSource}
              transFormData={transFormData}
              filterFields={filterRows}
              searchBox={{ fieldName: "name,email,phoneNumber" }}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          {apiUrl !== null && (
            <ConfirmationPopup
              apiUrl={apiUrl}
              id={selectedId!}
              confirmMessage="Are you sure you want to continue?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleConfirm}
              type={action}
              bodyData={bodyData}
            />
          )}
        </Grid>
      </Grid>
      <AddDoctorDialog
        open={addDoctorOpen}
        onClose={() => setAddDoctorOpen(false)}
        onSuccess={() => dispatch(resetDataComponent("doctorListGrid"))}
      />
    </Grid>
  );
});
